"use client"

import * as React from "react"
import { AsYouType } from "libphonenumber-js"

export type PhoneInputVariant = "default" | "glass"

export type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> & {
  value?: string
  onChange?: (value: string) => void
  isInvalid?: boolean
  variant?: PhoneInputVariant
}

export const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  (
    {
      className = "",
      isInvalid = false,
      variant = "default",
      value = "",
      onChange,
      ...props
    },
    ref,
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value

      // Используем AsYouType для автоматического форматирования
      const formatter = new AsYouType()
      const formatted = formatter.input(inputValue)

      if (onChange) {
        onChange(formatted)
      }
    }

    const common = "w-full rounded-md transition focus:outline-hidden h-11 px-3"
    const baseDefault =
      "border bg-white text-slate-900 placeholder-slate-400 focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 dark:bg-white dark:text-slate-900 dark:placeholder-slate-500"
    const baseGlass =
      "border bg-white/60 dark:bg-gray-800 backdrop-blur-xl text-slate-900 dark:text-white placeholder-slate-500 dark:placeholder-white/60 focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-0"

    const borders = isInvalid
      ? "border-red-500 focus-visible:ring-red-500"
      : variant === "glass"
        ? "border-slate-300 dark:border-white/20"
        : "border-slate-300 dark:border-slate-200"

    const base = variant === "glass" ? baseGlass : baseDefault

    return (
      <input
        ref={ref}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={value}
        onChange={handleChange}
        className={[common, base, borders, className].join(" ")}
        {...props}
      />
    )
  },
)

PhoneInput.displayName = "PhoneInput"
